/* eslint-disable */

import Vue from 'vue'
import App from './App.vue'
// import router from './router'
import store from './store/index'

import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { VAutocomplete } from 'vuetify/lib';
import { createVPhoneInput } from 'v-phone-input';
// import 'v-phone-input/dist/v-phone-input.css';
// import 'flag-icons/css/flag-icons.min.css';


Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new VueIntegration({Vue, attachProps: true, logErrors: true})],
})

// UI Frameworks
import vuetify from '@/plugins/vuetify'

// Globally registered components that are used frequently, don't need to be imported
import TranslatedText from './components/translation/TranslatedText'
import GlobalLabel from './components/translation/GlobalLabel'
Vue.component('TranslatedText', TranslatedText)
Vue.component('GlobalLabel', GlobalLabel)
Vue.component('VAutocomplete', VAutocomplete);

// Custom element framework
import 'document-register-element/build/document-register-element'
import vueCustomElement from 'vue-custom-element'
Vue.use(vueCustomElement)

const vPhoneInput = createVPhoneInput({
    countryIconMode: 'svg',
    enableSearchingCountry: true,
    countryGuesser: { 
        guess: function() {
            // Return the country code from the store or a default
            const countryCode = store.getters.countryCode;
            return Promise.resolve(countryCode || 'US');
        }
    }
});

Vue.use(vPhoneInput);

import VueMask from 'v-mask'
Vue.use(VueMask);

Vue.config.productionTip = false


// App.router = router

App.store = store

new Vue({
    vuetify,    
    render: h => h(App),
}).$mount('#app')

//Vue.customElement('vue-widget', App)